export default __webpack_public_path__ + "static/media/b3.28211939.png";